import { getContent } from '../store/ContentStore'; 

export const loadHeaderLabelsEn = () => {
    const lb = getContent("header.", "en");

    if (!lb || !lb.en) {
        return [];
    }
    
    const englishLabels = lb.en; 
    
    const tabKeys = Object.keys(englishLabels)
        .filter(key => key.startsWith('header.tab'));

    tabKeys.sort((a, b) => {
        const numA = parseInt(a.match(/tab(\d+)/)[1]);
        const numB = parseInt(b.match(/tab(\d+)/)[1]);
        return numA - numB;
    });

    const labels = tabKeys.map(fullKey => {
        const label = englishLabels[fullKey];
        const firstWord = label.split(' ')[0];
        
        return {
            label: englishLabels[fullKey],
            id: `${firstWord.toLowerCase()}-section`,
        };
    });
    
    return labels;
};

export const loadHeaderLabelsRo = () => {
    const lbRo = getContent("header.", "ro");
  
    const lbEn = getContent("header.", "en"); 

    if (!lbRo || !lbRo.ro || !lbEn || !lbEn.en) {
        return [];
    }
    
    const romanianLabels = lbRo.ro; 
    const englishLabels = lbEn.en;
   
    const tabKeys = Object.keys(romanianLabels)
        .filter(key => key.startsWith('header.tab'));

    tabKeys.sort((a, b) => {
        const numA = parseInt(a.match(/tab(\d+)/)[1]);
        const numB = parseInt(b.match(/tab(\d+)/)[1]);
        return numA - numB;
    });

    const labels = tabKeys.map(fullKey => {
        const roLabel = romanianLabels[fullKey];
     
        const enLabel = englishLabels[fullKey] || roLabel;
        const firstEnglishWord = enLabel.split(' ')[0];
        
        return {
            label: roLabel,
            id: `${firstEnglishWord.toLowerCase()}-section`,
        };
    });
    
    return labels;
};